import React from 'react';
import { 
  Box, 
  Card, 
  CardContent, 
  Typography, 
  Divider, 
  Grid,
  Paper,
  useTheme
} from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

const ModelLicenseDisplay = (licenseData = {
  license: "",
  usage_permission_generate: Math.random() > 0.5,
  usage_permission_online_training: Math.random() > 0.5,
  usage_permission_no_credit: Math.random() > 0.5,
  usage_permission_derivative: Math.random() > 0.5,
  usage_permission_derivative_license: Math.random() > 0.5,
  usage_permission_redistribute: Math.random() > 0.5,
  commercial_license_no_rights: Math.random() > 0.5,
  commercial_license_service: Math.random() > 0.5,
  commercial_license_derivative: Math.random() > 0.5
}) => {
  const theme = useTheme();

  const PermissionItem = ({ isEnabled, label, description }) => (
    <Paper 
      elevation={0} 
      sx={{
        p: 2,
        borderLeft: '4px solid',
        borderColor: isEnabled ? theme.palette.primary.main : theme.palette.grey[300],
        bgcolor: theme.palette.grey[50],
        opacity: isEnabled ? 1 : 0.6,
        display: 'flex',
        alignItems: 'flex-start',
        borderRadius: 1
      }}
    >
      <Box mr={2} color={isEnabled ? theme.palette.primary.main : theme.palette.grey[400]}>
        {isEnabled ? (
          <CheckCircleIcon fontSize="small" />
        ) : (
          <CancelIcon fontSize="small" />
        )}
      </Box>
      <Box>
        <Typography variant="subtitle2">{label}</Typography>
        {description && (
          <Typography variant="caption" color="textSecondary" sx={{ display: 'block', mt: 0.5 }}>
            {description}
          </Typography>
        )}
      </Box>
    </Paper>
  );

  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', p: 3 }}>
      <Card variant="outlined">
        <Box sx={{ p: 2, bgcolor: theme.palette.grey[50], borderBottom: `1px solid ${theme.palette.divider}` }}>
          <Typography variant="h6" component="h2">利用許諾範囲</Typography>
        </Box>
        
        <CardContent>
          <Box sx={{ 
            borderLeft: `4px solid ${theme.palette.primary.main}`,
            pl: 2,
            py: 0.5,
            mb: 3
          }}>
            <Typography variant="subtitle1" fontWeight="bold">
              ライセンス
            </Typography>
          </Box>
          
          <Grid container spacing={2} sx={{ mb: 4 }}>
            <Grid item xs={12} md={6}>
              {licenseData.license}
            </Grid>
          </Grid>

          <Box sx={{ 
            borderLeft: `4px solid ${theme.palette.primary.main}`,
            pl: 2,
            py: 0.5,
            mb: 3
          }}>
            <Typography variant="subtitle1" fontWeight="bold">
              このモデルを使用する際、ユーザーに以下の許可を与えます
            </Typography>
          </Box>
          
          <Grid container spacing={2} sx={{ mb: 4 }}>
            <Grid item xs={12} md={6}>
              <PermissionItem 
                isEnabled={licenseData.usage_permission_generate} 
                label="アワートAIの生成機能で使用" 
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <PermissionItem 
                isEnabled={licenseData.usage_permission_online_training} 
                label="アワートAIでのオンライントレーニングベースモデルとして使用" 
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <PermissionItem 
                isEnabled={licenseData.usage_permission_no_credit} 
                label="クレジットなしで使用する" 
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <PermissionItem 
                isEnabled={licenseData.usage_permission_derivative} 
                label="モデルの派生利用を許可する" 
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <PermissionItem 
                isEnabled={licenseData.usage_permission_derivative_license} 
                label="モデルの派生後、別のライセンスを適用可能" 
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <PermissionItem 
                isEnabled={licenseData.usage_permission_redistribute} 
                label="モデルを再配布する" 
              />
            </Grid>
          </Grid>
          
          <Divider sx={{ my: 4 }} />
          
          <Box sx={{ 
            borderLeft: `4px solid ${theme.palette.primary.main}`,
            pl: 2,
            py: 0.5,
            mb: 3
          }}>
            <Typography variant="subtitle1" fontWeight="bold">
              商用ライセンス
            </Typography>
          </Box>
          
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <PermissionItem 
                isEnabled={licenseData.commercial_license_no_rights} 
                label="生成画像への権利不行使" 
                description="このモデルで生成された画像に対して、モデル製作者として権利を主張しません" 
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <PermissionItem 
                isEnabled={licenseData.commercial_license_service} 
                label="画像生成サービスとしての商用利用を許可する" 
              />
            </Grid>
            
            <Grid item xs={12} md={6}>
              <PermissionItem 
                isEnabled={licenseData.commercial_license_derivative} 
                label="販売またはモデルの派生による商用利用を許可する" 
              />
            </Grid>
          </Grid>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ModelLicenseDisplay;